{
  "version": 1,
  "asset_id": "0a18dcca-1b85-4601-88d2-fc296ca9d643",
  "project_id": "a3729fa2-e85b-4f5b-84b2-0934e880c580",
  "url": "/__l5e/assets-v1/0a18dcca-1b85-4601-88d2-fc296ca9d643/ss01-card-p2.webp",
  "r2_key": "a/v1/a3729fa2-e85b-4f5b-84b2-0934e880c580/0a18dcca-1b85-4601-88d2-fc296ca9d643/ss01-card-p2.webp",
  "original_filename": "ss01-card-p2.webp",
  "size": 127156,
  "content_type": "image/webp",
  "created_at": "2026-09-12T16:22:48Z"
}
